import { DateTime } from "luxon";
import { timezone } from "./utils";

export const isWithinRenewalWindow = (examDate: Date, expirationDate: Date) => {
  const windowStart = DateTime.fromJSDate(expirationDate)
    .setZone(timezone)
    .minus({ months: 12 })
    .toJSDate();

  return examDate >= windowStart && examDate <= expirationDate;
};
